import React from "react";
import StorefrontIcon from '@mui/icons-material/Storefront';
import DetailsIcon from '@mui/icons-material/Details';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import ReportIcon from '@mui/icons-material/Report';
import ReceiptLongSharpIcon from '@mui/icons-material/ReceiptLongSharp';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import TroubleshootOutlinedIcon from '@mui/icons-material/TroubleshootOutlined';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

export const subNavData = [
    {
        id: 1,
        icon: <TroubleshootOutlinedIcon />,
        text: "Traces",
        link: "traces-exceptions/traces"
    },
    {
        id: 2,
        icon: <BugReportOutlinedIcon />,
        text: "Exceptions",
        link: "traces-exceptions/exceptions"
    },
    {
        id: 3,
        icon: <EmailOutlinedIcon />,
        text: "EmailTraces",
        link: "traces-exceptions/emailTraces"
    }
];

export const navData = [

    {
        id: 1,
        icon: <StorefrontIcon />,
        text: "Firmware Store",
        link: ""
    },
    {
        id: 2,
        icon: <DetailsIcon />,
        text: "Site Details",
        link: "sitedetails"
    },
    {
        id: 3,
        icon: <PersonAddIcon />,
        text: "User Management",
        link: "usermanagement"
    },

    {
        id: 4,
        icon: <NewReleasesIcon />,
        text: "Release Management",
        link: "releasemanagement"
    },

    {
        id: 5,
        icon: <ReportIcon />,
        text: "Firmware Report",
        link: "firmwarereport"
    },
    {
        id: 6,
        icon: <ReceiptLongSharpIcon />,
        text: "Contract Management",
        link: "contractmanagement"
    },
    {
        id: 7,
        icon: <ReportProblemOutlinedIcon />,
        text: "Logs/Traces",
        link: "logs-traces",
        children: subNavData
    }
]